import React, { useState } from "react";
//redux imports
import { Provider } from "react-redux";
import store from "./redux/store";
//redux imports

// notifications alerts
import 'react-notifications-component/dist/theme.css'
import ReactNotification from 'react-notifications-component'
import 'animate.css/animate.min.css';
// notifications alerts

//multilingual imports
import { IntlProvider } from "react-intl";
import en from "./languages/en.json";
import it from "./languages/it.json";
//multilingual imports

//router
import { BrowserRouter } from "react-router-dom";
import BaseRoutes from "./routes";
//router

//global popup
import BasePopup, { BasePopupContext } from './components/BasePopup';
import { initialPopupState } from "./constants";
//global popup

import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'


const App = () => {
  let persistor = persistStore(store);
  const [popupState, setPopupState] = useState([]);

  const openPopup = (params) => setPopupState((old) => [...old, params]);
  const closePopup = () =>
    setPopupState((old) =>
      old.filter((item, index) => (index !== old.length - 1 ? true : false))
    );
  const closeAllPopup = () => setPopupState([]);

  const global_popup_context_data = {
    popupState,
    setPopup: openPopup,
    closePopup,
    closeAllPopup,
  };
  // state for popup

  return (
    <>
      <IntlProvider messages={en} locale="en" defaultLocale="en">
        <Provider store={store}>
          <PersistGate persistor={persistor}>

            <BasePopupContext.Provider value={global_popup_context_data}>

              <BrowserRouter>

                <ReactNotification />
                <BaseRoutes />
                <BasePopup />

              </BrowserRouter>

            </BasePopupContext.Provider>
          </PersistGate>
        </Provider>
      </IntlProvider>
    </>
  );
}

export default App;
